import { render } from "./GruposMetas.vue?vue&type=template&id=425cc16a"
import script from "./GruposMetas.vue?vue&type=script&lang=js"
export * from "./GruposMetas.vue?vue&type=script&lang=js"

import "./GruposMetas.vue?vue&type=style&index=0&id=425cc16a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__